<template id="dataSheetTmpl">
	<div>
		
			<div class="font-weight-bold mt-2 mb-2">{{ $t('msg.dataRelativeLastSave') }}</div>
			
			<v-expansion-panels class="mt-2" v-if="dataSheet != null">
				<v-expansion-panel v-for="(item, indexService) in dataSheet" :key="indexService">
					<div v-if="item != null && item.service != null">
						<v-expansion-panel-header class="font-weight-bold text-uppercase">
							{{$root.findTranslationInList(item.service.service_name)}}
						</v-expansion-panel-header>

						<v-expansion-panel-content>
							
							<v-row no-gutters>
								<v-col cols="12">
									<span class="font-weight-bold">{{ $t('lbl.serviceCode') }}: </span>{{item.service.service_id}}
								</v-col>
							</v-row>
							<v-row no-gutters class="mt-3">
								<v-col cols="12" class="font-weight-bold">
									{{$root.findTranslationInList(item.service.service_name)}}
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12">
									{{$root.findTranslationInList(item.service.service_description)}}
								</v-col>
							</v-row>
							
							<v-divider></v-divider>

							<v-row no-gutters>
								<v-col cols="12">
									<span class="font-weight-bold">{{ $t('lbl.serviceType') }}: </span>
								</v-col>
								<v-col cols="12" v-for="(tagTmp, indexTag) in item.service.tags" :key="indexTag">
								- {{findTranslationInList(tagTmp) }}
								</v-col>
							</v-row>
							<v-divider></v-divider>
							
							<!-- DATASHEET - NOTE HTML -->
							<div v-if="$root.findTranslationInList(item.service.service_notes) != ''">
								<v-row no-gutters>
									<v-col cols="12">
										<span class="font-weight-bold">{{ $t('lbl.serviceNoteHtml') }}</span>
									</v-col>
								</v-row>
								<v-row no-gutters class="mt-3 mb-3">
									<v-col cols="12">
										<div v-html="$root.findTranslationInList(item.service.service_notes)"></div>
									</v-col>
								</v-row>
							</div>
							<v-divider></v-divider>

							<!-- DATASHEET - NOTE UTENTE -->	
							<v-row no-gutters>
								<v-col cols="12">
									<span class="font-weight-bold">{{ $t('lbl.serviceNote') }}</span>
								</v-col>
							</v-row>
							<v-row no-gutters class="mt-3 mb-3">
								<v-col cols="12">
								{{item.notes.it_IT}}
								</v-col>
							</v-row>
							<v-divider></v-divider>
							
						</v-expansion-panel-content>
					</div>
				</v-expansion-panel>
			</v-expansion-panels>

			<div v-else>
				<span class="font-weight-bold" >{{ $t('err.noelem') }}</span>
			</div>	
		
		
		
	</div>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
	i18n,
	data: () => ({
		dataSheet: null,
	}),
    props: ['orgitem', 'prjitem', 'servicesList'],
	created() 
	{
		
	},
    mounted() 
	{
		//=== START LISTEN EVENTS
		events.$on(constants.EVENT_DO_INIT_DATASHEET, (prjObj, servicesList) => {
			this.initDataSheet(prjObj, servicesList);
		});
		//=== SE IL PROGETTO VIENE CARICATO PRIMA DELl EVENTO
		if(!this.isEmptyObj(this.prjitem) && !this.isEmptyObj(this.prjitem.services) && !this.isEmptyObj(this.servicesList) && Array.isArray(this.servicesList) && this.servicesList.length > 0 )
		{
			this.initDataSheet(this.prjitem, this.servicesList);
		}
	},
	destroyed() 
	{
		//=== STOP LISTEN EVENTS
		events.$off(constants.EVENT_DO_INIT_DATASHEET);
	},
	methods: 
	{	
		initDataSheet(prjObj, servicesList)
		{
			this.dataSheet= [];
			if(!this.isEmptyObj(prjObj) && !this.isEmptyObj(prjObj.services))
			{
				
				for (var i = 0; i < prjObj.services.length; i++) 
				{
					var serviceObj = prjObj.services[i];	
				
					var obj2add = this.getEmptyDataSheetElement();
					obj2add.service_id = serviceObj.service_id;
					
					if(prjObj.state == constants.PRJ_STATUS_DONE)
					{
						// PRENDO OGGETTO SERVIZIO DA PROGETTO
						obj2add.service = Object.assign({}, serviceObj.service);
					} 
					else 
					{
						// PRENDO OGGETTO SERVIZIO DA CATALOGO
						obj2add.service = this.findServiceObjInCatalogue(serviceObj.service_id, servicesList);
					} 

					obj2add.notes = Object.assign({}, serviceObj.notes);
					obj2add.contents_data = Object.assign({}, serviceObj.contents_data);
					
					this.dataSheet.push(obj2add);
				}
			} 
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.generic')+ " 02");
			}
		},
		getEmptyDataSheetElement(){
			var obj =  { 
                "service_id": null, 
				"service": null,
                "notes": {
                    "it_IT": ""
                },
                "contents_data":{}
			}
			return obj;	
        },
	}
}
</script>